import React from 'react'
import PropTypes from 'prop-types'
import styles from './PublishModal.scss'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Form, FormGroup, Label, Input } from 'reactstrap'
import moment from 'moment'
window.moment = moment

const DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm'

class PublishModalContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = this._scheduledForToNextState(props.scheduledFor)
  }

  _scheduledForToNextState = (scheduledFor) => {
    let isInPast
    if (scheduledFor) {
      // now - scheduledFor
      let diff = moment().diff(moment(scheduledFor))
      isInPast = isNaN(diff) || diff > 0
    }
    if (isInPast || !scheduledFor) {
      scheduledFor = undefined
    }
    let nextState = {
      isPublishNow: !scheduledFor
    }
    nextState.scheduledFor = moment(scheduledFor).format(DATETIME_FORMAT)
    return nextState
  }

  componentWillUpdate (props) {
    if (props.scheduledFor !== this.props.scheduledFor) {
      this.setState(this._scheduledForToNextState(props.scheduledFor))
    }
  }

  onKeyDown = (synthetic, event) => {
    // return
    if (synthetic.keyCode === 13) {
      this.onSubmit(synthetic)
    }
  }

  onCancel = () => {
    this.props.toggle()
  }

  onSubmit = async e => {
    e.preventDefault()
    let didSucceed = false

    if (this.state.isPublishNow) {
      // publish now
      if (this.props.scheduledFor) {
        // remove previous scheduling
        this.props.onPublishLater(null)
      }
      await this.props.onPublishNow()
      didSucceed = true
    } else {
      // schedule

      // validation
      if (this.input && !this.input.checkValidity()) {
        return this.input.reportValidity()
      }

      didSucceed = await this.props.onPublishLater(this.state.scheduledFor)
    }
    if (didSucceed) {
      this.props.toggle()
    }
  }

  getDateTimeRef = input => {
    if (input) {
      this.input = input
    }
  }

  onChangeToScheduledPublishing = () => {
    const scheduledFor = this.state.scheduledFor
      ? this.state.scheduledFor
      : moment().format(DATETIME_FORMAT)
    this.setState({isPublishNow: false, scheduledFor})
  }

  onChangeToPublishNow = () => {
    this.setState({isPublishNow: true})
  }

  onChangePublishDateTime = event => {
    this.setState({scheduledFor: event.target.value})
  }

  render () {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={styles.PublishModal}>
        <ModalHeader toggle={this.props.toggle}>Publish Draft</ModalHeader>
        <ModalBody onKeyDown={this.onKeyDown}>

          <Form inline>
            <FormGroup check>
              <Label check>
                <Input type='radio' name='isPublishNow'
                  checked={this.state.isPublishNow}
                  onChange={this.onChangeToPublishNow} />{' '}
                Publish Now
              </Label>
            </FormGroup>
            &nbsp;&nbsp;
            <FormGroup check>
              <Label check selected>
                <Input type='radio' name='isPublishNow'
                  checked={!this.state.isPublishNow}
                  onChange={this.onChangeToScheduledPublishing} />{' '}
                Scheduled Publishing{' '}
              </Label>
            </FormGroup>
          </Form>

          {!this.state.isPublishNow &&
            <Form name='PublishModalForm' style={{margin: '20px 0'}}>
              <FormGroup>
                <FormGroup>
                  <Input type='datetime-local'
                    name='scheduledFor' id='scheduledFor'
                    getRef={this.getDateTimeRef}
                    min={moment().format(DATETIME_FORMAT)}
                    placeholder='Enter time of scheduled publishing'
                    onClick={e => e.stopPropagation()}
                    onChange={this.onChangePublishDateTime}
                    required
                    value={this.state.scheduledFor} />
                </FormGroup>
              </FormGroup>
            </Form>
          }

          <div className='debug-block' style={{display: 'none'}}>
            state
            <pre>{JSON.stringify(this.state, null, 4)}</pre>
          </div>

        </ModalBody>
        <ModalFooter>
          <Button form='PublishModalForm' color='secondary' onClick={this.onCancel}>Cancel</Button>
          <Button form='PublishModalForm' color='primary' type='submit' onClick={this.onSubmit}>
            {
              this.state.isPublishNow
              ? 'Publish'
              : 'Save'
            }
          </Button>{' '}
        </ModalFooter>
      </Modal>
    )
  }
}

PublishModalContainer.propTypes = {
  scheduledFor: PropTypes.string,
  onPublishNow: PropTypes.func.isRequired,
  onPublishLater: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired
}

export default PublishModalContainer



// WEBPACK FOOTER //
// ./src/components/PublishModal/PublishModalContainer.js